import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import Projects from "./pages/Projects/Projects";
import ScrollToTop from "./utils/scollToTop";
import { useMantineColorScheme, useComputedColorScheme } from "@mantine/core";
import { useEffect, useState } from "react";
import { getProjects } from "./redux/features/projects/projectsSlice";
import Project from "./pages/Project/Project";
import Aside from "./components/Aside/Aside";

function App() {
  const dispatch = useDispatch();
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme("light");
  const toggleColorScheme = () => {
    // Check if there is a stored color scheme in local storage
    const storedColorScheme = localStorage.getItem(
      "mantine-color-scheme-value"
    );

    // If there is no stored color scheme, use the computedColorScheme
    const currentColorScheme = storedColorScheme || computedColorScheme;

    // Determine the new color scheme
    const newColorScheme = currentColorScheme === "dark" ? "light" : "dark";

    // Set the color scheme in Mantine
    setColorScheme(newColorScheme);

    // Add or remove the 'dark' class on the html element
    document.documentElement.classList.toggle(
      "dark",
      newColorScheme === "dark"
    );

    // Store the new color scheme in local storage
    localStorage.setItem("mantine-color-scheme-value", newColorScheme);
  };

  // Initialize color scheme based on local storage on component mount
  useEffect(() => {
    const storedColorScheme = localStorage.getItem(
      "mantine-color-scheme-value"
    );
    if (storedColorScheme) {
      setColorScheme(storedColorScheme);
      document.documentElement.classList.toggle(
        "dark",
        storedColorScheme === "dark"
      );
    }
  }, []);

  useEffect(() => {
    dispatch(getProjects({ page: 1, limit: 10 }));
  }, []);

  const [isHovered, setIsHovered] = useState(false);
  // Retrieve the value from localStorage or default to the initial value
  const storedIsWideScreen = localStorage.getItem("isWideScreen");
  const initialIsWideScreen = storedIsWideScreen
    ? JSON.parse(storedIsWideScreen)
    : window.innerWidth > 1280;

  const [isWideScreen, setIsWideScreen] = useState(initialIsWideScreen);

  const handleAside = () => {
    // Toggle the state and save it to localStorage
    const updatedIsWideScreen = !isWideScreen;
    setIsWideScreen(updatedIsWideScreen);
    localStorage.setItem("isWideScreen", JSON.stringify(updatedIsWideScreen));
  };

  // Update the stored value in localStorage when isWideScreen changes
  useEffect(() => {
    localStorage.setItem("isWideScreen", JSON.stringify(isWideScreen));
  }, [isWideScreen]);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleResize = () => {
    if (window.innerWidth < 1281) {
      setIsWideScreen(window.innerWidth > 1280);
    }
  };

  useEffect(() => {
    // Attach the resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures the effect runs only once on mount

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <main>
          <div className="flex h-full min-h-[100vh] w-full max-w-[100vw] false">
            <Aside
              handleAside={handleAside}
              isWideScreen={isWideScreen}
              isHovered={isHovered}
              handleMouseEnter={handleMouseEnter}
              handleMouseLeave={handleMouseLeave}
            />
            <Routes>
              <Route
                path="/"
                element={
                  <Projects
                    isWideScreen={isWideScreen}
                    toggleColorScheme={toggleColorScheme}
                    computedColorScheme={computedColorScheme}
                  />
                }
              />
              <Route
                path="/projects/:handle"
                element={
                  <Project
                    toggleColorScheme={toggleColorScheme}
                    computedColorScheme={computedColorScheme}
                  />
                }
              />
            </Routes>
          </div>
        </main>
      </BrowserRouter>
    </>
  );
}

export default App;
